import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.account.settings', {
		url: '/account',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})


}


/** WEBPACK FOOTER **
 ** ./src/main/account/settings/routes.js
 **/